import { takeEvery } from "@redux-saga/core/effects";
import { FormSettingsTypes } from "./../types";
import { changeGeneralSettingsSaga } from "./changeGeneralSettingsSaga";
import { updateNativeSettingsSaga } from "./updateNativeSettingsSaga";
import { changeLimitsSettingsSaga } from "./getChangedFormLimitsSettingsSaga";
import { changeNotificationsSettingsSaga } from "./changeNotificationsSettingsSaga";
import { changeSaveProgressSettingsSaga } from "./changeSaveProgressSettingsSaga";
import { changeConfirmationSettingsSaga } from "./changeConfirmationSettingsSaga";

export default function* SettingSaga() {
    yield takeEvery(FormSettingsTypes.CHANGE_GENERAL_SETTING_REQUEST, changeGeneralSettingsSaga);
    yield takeEvery(FormSettingsTypes.CHANGE_LIMITS_SETTING, changeLimitsSettingsSaga);
    yield takeEvery(FormSettingsTypes.CHANGE_NOTIFICATIONS_SETTING, changeNotificationsSettingsSaga);
    yield takeEvery(FormSettingsTypes.CHANGE_SAVE_PROGRESS_SETTING, changeSaveProgressSettingsSaga);
    yield takeEvery(FormSettingsTypes.CHANGE_CONFIRMATION_SETTING, changeConfirmationSettingsSaga);
    yield takeEvery(FormSettingsTypes.CHANGE_NATIVE_SETTING_REQUEST, updateNativeSettingsSaga);
}
